// backend api url
let BACKEND_API_URL = process.env.REACT_APP_BACKEND_URL;

// local storage access token key
const LOCAL_STORAGE_AUTH_KEY = "access_token";
const LOCAL_STORAGE_PRE_AUTH_KEY = "pre-access-token";

// default formats
const FORMATS = {
  dateFormat: "DD MMMM YYYY",
  dateTimeFormat: "DD MMMM YYYY HH:mm",
  systemDateFormat: "YYYY-MM-DD",
  systemDateTimeFormat: "YYYY-MM-DD HH:mm:ss",
};

// global error message
const ERROR_MESSAGE =
  "İşleminiz sırasında bir hata oluştu. Lütfen tekrar deneyiniz veya sorunun devam etmesi halinde destek biriminden yardım isteyiniz.";

const constants = {
  LOCAL_STORAGE_AUTH_KEY,
  LOCAL_STORAGE_PRE_AUTH_KEY,
  BACKEND_API_URL,
  ERROR_MESSAGE,
  FORMATS,
};

export default constants;
